import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import TabContainer from "../../../components/components/TabContainer";
import { TitleBar } from "@shopify/app-bridge-react";
import { Route, Routes, Navigate } from "react-router-dom";
import {
  CodeMinor,
  SettingsMinor,
  LanguageMinor,
  TemplateMinor,
} from "@shopify/polaris-icons";
import ThemeLanguageEdit from "../theme/pages/language/Edit";
import ThemeSettingsEdit from "./pages/settings/Edit";
import ThemeTemplatesEdit from "./pages/templates/Edit";

import { AppContext } from "../../../components/global/appContext";

function ThemeNavWrapper({ children }) {
  const { t } = useTranslation();
  const { appProxyLandingURL, appProxyDirectoryURL, enabledFeatures } =
    useContext(AppContext);

  return (
    <TabContainer
      sections={[
        {
          title: t("themes.navigation.sublimeTheme"),
          fill: true,
          items: [
            {
              label: t("themes.navigation.settings"),
              url: "/themes/live/settings",
              icon: SettingsMinor,
            },
            {
              label: t("themes.navigation.language"),
              url: "/themes/live/language",
              icon: LanguageMinor,
            },
            {
              label: t("themes.navigation.templates"),
              url: "/themes/live/templates",
              icon: CodeMinor,
              disabled: !enabledFeatures.includes("custom_themes"),
            },
          ],
        },
        {
          items: [
            {
              label: t("themes.navigation.changeTheme"),
              url: "/themes",
              icon: TemplateMinor,
              exactMatch: true,
            },
          ],
          separator: true,
        },
      ]}
    >
      <TitleBar
        title={t("themes.navigation.sublimeTheme")}
        breadcrumbs={[{ content: t("themes.title"), url: "/themes" }]}
        secondaryActions={[
          {
            content: t("themes.navigation.viewDirectory"),
            url: appProxyDirectoryURL,
            external: true,
          },
          {
            content: t("themes.navigation.viewLandingPage"),
            url: appProxyLandingURL,
            external: true,
          },
        ]}
      />
      {children}
    </TabContainer>
  );
}

export default function ThemeIndex(props) {
  return (
    <Routes>
      <Route index element={<Navigate to="settings" />} />
      <Route
        path="settings"
        element={
          <ThemeNavWrapper>
            <ThemeSettingsEdit />
          </ThemeNavWrapper>
        }
      />
      <Route
        path="language"
        element={
          <ThemeNavWrapper>
            <ThemeLanguageEdit />
          </ThemeNavWrapper>
        }
      />
      <Route path="templates/*" element={<ThemeTemplatesEdit />} />
    </Routes>
  );
}
